import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeEstudioAmbiental } from "../../../../../../redux/actions/resolucion";
import EstudiosAmbientalesTable from "./EstudiosAmbientalesTable";
import EstudiosAmbientalesFormContainer from "./form/EstudiosAmbientalesFormContainer";



const EstudiosAmbientalesTableContainer = ({ handleNextStep, handlePreviousStep, stepper }) => {
    const dispatch = useDispatch();
    const [openEstudiosAmbientalesForm, setOpenEstudiosAmbientalesForm] = useState(false);
    const [estudioAmbiental, setEstudioAmbiental] = useState();
    const estudios = useSelector((state) => state.resolucion.abmSustancia.estudios);
    const handleGoNext = () => {
        handleNextStep("Part5");
    };

    const handleGoBack = () => {
        handlePreviousStep("Part3");
    }

    const handleOpenForm = (estudio) => {
        setEstudioAmbiental(estudio);
        setOpenEstudiosAmbientalesForm(true);
    }
    const handleDelete = (data) => {
        dispatch(removeEstudioAmbiental(data.map((v) => v.index)));
    }


    return (
        <>
            <EstudiosAmbientalesTable
                handleGoBack={handleGoBack}
                handleGoNext={handleGoNext}
                data={estudios}
                handleOpenForm={handleOpenForm}
                handleDelete={handleDelete}
                stepper={stepper}
            />
            <EstudiosAmbientalesFormContainer
                open={openEstudiosAmbientalesForm}
                formValues={estudioAmbiental}
                handleClose={() => setOpenEstudiosAmbientalesForm(false)}

            />
        </>

    )
}

export default EstudiosAmbientalesTableContainer;